<template>
    <div>
        <div class="reset-container">
            <form
                novalidate
                @submit.prevent="validateOnSubmit"
            >
                <p>Reset image cache</p>

                <response-callout
                    :type="statusType"
                    :messages="status"
                />

                <div
                    class="form-group"
                    :class="{'has-error': errors.has('account')}"
                >
                    <input
                        v-model.trim="account"
                        v-validate="'required'"
                        type="text"
                        name="account"
                        class="form-control"
                        placeholder="Account"
                    >
                </div>
                <div
                    class="form-group"
                    :class="{'has-error': errors.has('password')}"
                >
                    <input
                        v-model="password"
                        v-validate="'required'"
                        type="password"
                        name="password"
                        class="form-control"
                        placeholder="Password"
                    >
                </div>

                <div class="row">
                    <div class="col-xs-12">
                        <div class="form-group">
                            <button
                                type="submit"
                                class="btn btn-primary"
                            >
                                Reset
                            </button>
                        </div>
                    </div>

                    <preloader :working="loading" />
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';

    import Preloader from './Preloader.vue';
    import ResponseCallout from './ResponseCallout.vue';

    import * as api from './api';

    export default {
        components: {
            Preloader,
            ResponseCallout,
        },
        data() {
            return {
                statusType: null,
                status: null,
                account: '',
                password: '',
                loading: false,
            };
        },
        methods: {
            validateOnSubmit() {
                this.$validator.validateAll().then((success) => {
                    if (!success) {
                        return;
                    }

                    this.loading = true;

                    axios.post('/api/v1/control/' + this.account + '/reset', {
                        key: this.password,
                    }).then(() => {
                        this.loading = false;

                        this.statusType = 'success';
                        this.status = ['Cache reset request submitted successfully'];
                    }).catch((error) => {
                        this.loading = false;

                        this.statusType = 'danger';
                        this.status = api.unpackError(error.response);
                    });
                });
            },
        },
    };
</script>

<style lang="less">
    .reset-container {
        max-width: 360px;

        margin-top: 20px;
        margin-left: auto;
        margin-right: auto;

        padding: 20px;

        border: 1px solid #d3dbe3;
        border-radius: 2px;
    }
</style>
